import { render } from "./XypValueRenderer.vue?vue&type=template&id=277c23a0&scoped=true&ts=true"
import script from "./XypValueRenderer.vue?vue&type=script&lang=ts"
export * from "./XypValueRenderer.vue?vue&type=script&lang=ts"

import "./XypValueRenderer.vue?vue&type=style&index=0&id=277c23a0&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-277c23a0"]])

export default __exports__